var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordManagerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 20.75H7.5C6.75 20.75 6.2 20.72 5.73 20.65C2.41 20.29 1.75 18.3 1.75 15V9C1.75 5.7 2.41 3.71 5.76 3.34C6.2 3.28 6.75 3.25 7.5 3.25H16.5C17.25 3.25 17.8 3.28 18.27 3.35C21.59 3.71 22.25 5.7 22.25 9V15C22.25 18.3 21.59 20.29 18.24 20.66C17.8 20.72 17.25 20.75 16.5 20.75ZM7.5 4.75C6.82 4.75 6.34 4.78 5.95 4.83C3.92 5.06 3.25 5.69 3.25 9V15C3.25 18.31 3.92 18.94 5.92 19.17C6.34 19.23 6.82 19.25 7.5 19.25H16.5C17.18 19.25 17.66 19.22 18.05 19.17C20.08 18.95 20.75 18.31 20.75 15V9C20.75 5.69 20.08 5.06 18.08 4.83C17.66 4.77 17.18 4.75 16.5 4.75H7.5Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10.75H13.5C13.09 10.75 12.75 10.41 12.75 10C12.75 9.59 13.09 9.25 13.5 9.25H17C17.41 9.25 17.75 9.59 17.75 10C17.75 10.41 17.41 10.75 17 10.75Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 11C9.54998 11 9.09998 10.55 9.09998 10C9.09998 9.45 9.53998 9 10.1 9H10.11C10.66 9 11.11 9.45 11.11 10C11.11 10.55 10.66 11 10.1 11Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09998 11C6.54998 11 6.09998 10.55 6.09998 10C6.09998 9.45 6.53998 9 7.09998 9C7.64998 9 8.09998 9.45 8.09998 10C8.09998 10.55 7.65998 11 7.09998 11Z",
    fill: "#292D32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.25H7.02001C6.61001 16.25 6.26001 15.91 6.26001 15.5C6.26001 15.09 6.59001 14.75 7.00001 14.75H17C17.41 14.75 17.75 15.09 17.75 15.5C17.75 15.91 17.41 16.25 17 16.25Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordManagerIcon);
export default __webpack_public_path__ + "static/media/password-manager-icon.516a93fa19f87cc28d83f6138694e088.svg";
export { ForwardRef as ReactComponent };